import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import { CmDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import CmNetworkProfile from 'components/Profile/CmNetworkProfile';

export default connect((state: RootState) => {
  return {
    data: state.networkShow.network as CmDetailsDataStructure,
  };
}, {})(CmNetworkProfile);
